import { createContext } from 'react';
import { AuthStore } from '@/src/features/app/store/auth/store';
import { useDefinedContext } from '@/src/utils/context/useDefinedContext';

export const AuthContext = createContext<AuthStore | undefined>(undefined);

export const useAuthContext = (): AuthStore => useDefinedContext(AuthContext);
